import React, { useEffect, useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { LogTypes } from '../../common/constants/LogTypes'
import useText from '../../common/hooks/useText'

const SearchFieldInput = styled.input`
    font-weight: 400;
    height: 34px;
    width: 100%;
    font-size: 14px;
    padding: 8px;
    font-weight: 300;
    opacity: 0.7;
    border-radius: 4px;
    border: 1px solid #cccccc;
`

export type WidgetDropdownFilterSearch = {
    setVisibleOptions: React.Dispatch<React.SetStateAction<LogTypes[]>>
    visibleOptions: LogTypes[]
    defaultOptions: LogTypes[]
    className?: ClassName
    style?: React.CSSProperties
}

export function WidgetDropdownFilterSearch({
    setVisibleOptions,
    visibleOptions,
    defaultOptions,
    className,
    style,
}: WidgetDropdownFilterSearch): React.ReactElement {
    const text = useText()
    const [searchValue, setSearchValue] = useState('')

    useEffect(() => {
        if (!searchValue) {
            setVisibleOptions(defaultOptions)
            return
        }

        const filtered = defaultOptions.filter((option) =>
            LogTypes[option].toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
        )
        if (JSON.stringify(filtered) === JSON.stringify(visibleOptions)) return

        setVisibleOptions(filtered)
    }, [searchValue])

    return (
        <SearchFieldInput
            className={cn(className)}
            style={style}
            type="text"
            value={searchValue}
            placeholder={text('msgSearch')}
            onChange={(event) => setSearchValue(event.target.value)}
            data-testid="WidgetDropdownFilterSearch"
        />
    )
}
